import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './RadioButtons.module.scss';
import Icon from '../Icon';

const RadioButtons = ({
    options = [],
    value,
    onChange,
    name,
    modifiers = [],
    disabledOptions = new Set(),
    showCheckmark = false,
}) => {
    const handleOptionClick = (optionValue) => {
        if (disabledOptions.has(optionValue)) return;

        if (onChange) {
            if (value === optionValue) {
                onChange(null);
            } else {
                onChange(optionValue);
            }
        }
    };

    const rootClasses = classNames(
        s.Root,
        ...(Array.isArray(modifiers) ? modifiers.map((mod) => s[mod]) : [])
    );

    const isFromFlowmap = modifiers.includes('Flowmap');

    return (
        <div className={rootClasses}>
            {options.map((option) => {
                const isSelected = value === option.value;
                const isDisabled =
                    disabledOptions.has(option.value) && !isSelected;
                const classes = classNames(s.Option, {
                    [s['Option--Selected']]: isSelected,
                    [s['Option--Disabled']]: isDisabled,
                });

                return (
                    <div
                        key={option.value}
                        className={classes}
                        onClick={() => handleOptionClick(option.value)}>
                        {isFromFlowmap ? (
                            <div className={s.Wrapper}>
                                <span className={s.Label}>{option.label}</span>
                                <span className={s.RadioMark} />
                                <input
                                    type="radio"
                                    name={name}
                                    value={option.value}
                                    checked={isSelected}
                                    disabled={isDisabled}
                                    onChange={() => {}}
                                    className={s.Input}
                                />
                            </div>
                        ) : (
                            <div className={s.Wrapper}>
                                <input
                                    type="radio"
                                    name={name}
                                    value={option.value}
                                    checked={isSelected}
                                    disabled={isDisabled}
                                    onChange={() => {}}
                                    className={s.Input}
                                />
                                <span className={s.RadioMark} />
                                <span className={s.Label}>{option.label}</span>
                                {showCheckmark && isSelected && (
                                    <Icon
                                        className={s.Checkmark}
                                        name="CheckSmallBlackBackground"
                                    />
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

RadioButtons.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    disabledOptions: PropTypes.instanceOf(Set),
};

export default RadioButtons;
